import * as React from 'react';
import { observer } from 'mobx-react';
import TimeIncrement from './TimeIncrement';
import WeekStartDay from './WeekStartDay';
import WorkWeek from './WorkWeek';
import ShowWeekNumbers from './ShowWeekNumbers';
import FirstWeekOfYear from './FirstWeekOfYear';
import WorkingHours from './WorkingHours';
import getShowWeekNumbers from '../selectors/getShowWeekNumbers';
var styles = require('./AppearanceFull.scss');
/**
 * Wrapper component which renders the individual settings inside calendar appearance option
 */
export default observer(function AppearanceFull() {
    return (React.createElement("div", { className: styles.appearanceWrapper },
        React.createElement(WeekStartDay, { showQuickSettingLabel: false }),
        React.createElement(TimeIncrement, null),
        React.createElement(WorkWeek, null),
        React.createElement(WorkingHours, null),
        React.createElement(ShowWeekNumbers, null),
        getShowWeekNumbers() && React.createElement(FirstWeekOfYear, null)));
});
//# sourceMappingURL=AppearanceFull.js.map